@if (authModal.isOpen()) {
  <div class="am-backdrop" (click)="close()"></div>
  <div class="am" role="dialog" aria-modal="true" [attr.aria-label]="i18n.t('auth.signInAria')">
    <button type="button" class="am__x" (click)="close()" [attr.aria-label]="i18n.t('common.close')">×</button>

    <div class="am__grid">
      <aside class="am__promo">
        <img class="am__promo-logo" appBrandLogo="customer" [onDark]="true" />
        <p class="am__promo-rating">4.3 ★ — loved by shoppers</p>

        <!-- Every number below comes from the platform's ERP reward settings (api/public/coins/rules).
             Nothing here is hard-coded: change the console and the pitch changes with it. Each line is
             also individually gated, so a platform that runs only one path never advertises the others. -->
        @if (rules(); as r) {
          @if (r.enabled && (r.signupFreeDeliveries > 0 || r.orderCoins > 0 || r.streakRewardEnabled)) {
            @if (r.signupFreeDeliveries > 0) {
              <h2 class="am__promo-headline">
                {{ r.signupFreeDeliveries }} free deliver{{ r.signupFreeDeliveries === 1 ? 'y' : 'ies' }},
                on us — just for joining
              </h2>
            } @else {
              <h2 class="am__promo-headline">{{ i18n.t('auth.modalTitle') }}</h2>
            }

            <ul class="am__perks">
              @if (r.signupFreeDeliveries > 0) {
                <li class="am__perk">
                  <span class="am__perk-ico" aria-hidden="true">🎁</span>
                  <span><strong>{{ r.signupFreeDeliveries }} free deliver{{ r.signupFreeDeliveries === 1 ? 'y' : 'ies' }}</strong>
                    the moment your account is created</span>
                </li>
              }
              @if (r.orderCoins > 0 && r.coinRedemptionEnabled) {
                <li class="am__perk">
                  <span class="am__perk-ico" aria-hidden="true">🪙</span>
                  <span>{{ i18n.t('auth.earnCoinsOnOrder', { coins: r.orderCoins }) }} —
                    {{ r.freeDeliveryCoinCost }} coins buys another free delivery</span>
                </li>
              }
              @if (r.streakRewardEnabled) {
                <li class="am__perk">
                  <span class="am__perk-ico" aria-hidden="true">🔥</span>
                  <span>{{ i18n.t('auth.checkInDays', { days: r.streakTargetDays }) }}</span>
                </li>
              }
              <li class="am__perk">
                <span class="am__perk-ico" aria-hidden="true">📍</span>
                <span>{{ i18n.t('auth.modalBenefits') }}</span>
              </li>
            </ul>
          } @else {
            <h2 class="am__promo-headline">{{ i18n.t('auth.modalTitle') }}</h2>
            <p class="am__promo-text">{{ i18n.t('auth.modalSub') }}</p>
          }
        } @else {
          <h2 class="am__promo-headline">{{ i18n.t('auth.modalTitle') }}</h2>
          <p class="am__promo-text">{{ i18n.t('auth.modalSub') }}</p>
        }
      </aside>

      <div class="am__main">
        <app-auth-panel [initialMode]="authModal.mode()" (authenticated)="onAuthenticated()"></app-auth-panel>
      </div>
    </div>
  </div>
}
